var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { ExprTag } from '@easyquery/core';
import { SimpleColumnRendererCB } from './simple_column_renderer';
var AggrFuncColumnRendererCB = /** @class */ (function (_super) {
    __extends(AggrFuncColumnRendererCB, _super);
    function AggrFuncColumnRendererCB() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AggrFuncColumnRendererCB.prototype.getClassesToAdd = function () {
        return _super.prototype.getClassesToAdd.call(this) + " " + this.cssPrefix + "-row " + this.cssPrefix + "-row-column-aggr";
    };
    AggrFuncColumnRendererCB.prototype.getAttribute = function () {
        return this.bar
            .getContext()
            .getModel()
            .getAttributeByIdSafe(this.column.expr.args[0].value);
    };
    AggrFuncColumnRendererCB.prototype.getDefaultCaption = function () {
        return this.getDefaultTitleText(this.baseAttr) + ' '
            + this.bar.getContext().getModel().getAggrFunctionCaption(this.column.expr.func);
    };
    AggrFuncColumnRendererCB.prototype.renderColumnTypeButton = function () {
        var button = _super.prototype.renderColumnTypeButton.call(this);
        if (button) {
            button.classList.add('aggregated');
            button.title = i18n.getText('ButtonToSimple');
        }
        return button;
    };
    AggrFuncColumnRendererCB.prototype.baseExpressionItemSelectedCallback = function (data, item) {
        var attrid = data.id;
        //this.column.expr.args[0].id = attrid;
        this.column.expr.args[0].setValue(attrid, true);
        this.column.caption = '';
        this.fireColumnChanged();
    };
    AggrFuncColumnRendererCB.prototype.changeTypeToSimple = function () {
        var query = this.column.getQuery();
        query.changeColumnType(this.column, ExprTag.EntityAttribute);
        this.fireColumnChanged();
    };
    AggrFuncColumnRendererCB.prototype.changeColumnTypeHandler = function (ev) {
        this.changeTypeToSimple();
    };
    return AggrFuncColumnRendererCB;
}(SimpleColumnRendererCB));
export { AggrFuncColumnRendererCB };
//# sourceMappingURL=aggrfunc_column_renderer.js.map